import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Box, Text} from '@salesforce/retail-react-app/app/components/shared/ui'

const EngravingInstructions = (props) => {
    const {maxLength, showInitialSpinner} = props
    return (
        <>
            {!showInitialSpinner && (
                <Box display={{base: 'block', md: 'none'}} marginTop="15px">
                    <Text color="gray.800" fontSize="13" fontWeight="400">
                        <FormattedMessage
                            id="engraving.type.initials"
                            defaultMessage="Type in initials or add a symbol. You can even combine them."
                        />
                    </Text>
                    <Text color="gray.800" fontSize="13" fontWeight="300" marginTop="5px">
                        {maxLength === 1 && (
                            <FormattedMessage
                                id="engraving.one.length.available"
                                defaultMessage="This piece has a max of 1 character(s)."
                            />
                        )}
                    </Text>
                </Box>
            )}
            {!showInitialSpinner && (
                <Box
                    className="engraving-instructions"
                    backgroundColor="gray.100"
                    width="100%"
                    borderRadius="5px"
                    padding="15px"
                    display="grid"
                    margin="20px 0 0 0"
                >
                    <Text
                        color="black.100"
                        fontSize="13px"
                        fontWeight="300"
                        letterSpacing="0.065px"
                        marginBottom="1px"
                    >
                        <FormattedMessage
                            id="engraving.understand"
                            defaultMessage="I understand that all engraved items..."
                        />
                    </Text>
                    {[
                        'are final sale and not eligible for discounts.',
                        'may slightly differ from preview.',
                        'are not available for pickup in-store.',
                        'are custom made for you and may take an additional 2-3 business days to process with ground shipping.'
                    ].map((line) => (
                        <Text
                            key={line}
                            color="black.100"
                            fontSize="13px"
                            display="inline-flex"
                            gap="10px"
                            marginLeft="15px"
                            fontWeight="300"
                            letterSpacing="0.065px"
                        >
                            <Text color="gray.800" width="fit-content">
                                •
                            </Text>{' '}
                            {line}
                        </Text>
                    ))}
                </Box>
            )}
        </>
    )
}

EngravingInstructions.propTypes = {
    maxLength: PropTypes.any,
    showInitialSpinner: PropTypes.any
}

export default EngravingInstructions
